import { API_AUTH } from "./common";

const PhiKhacHangKyApi = {
  list: ({ type }) =>
    API_AUTH.get(`quan-ly-cho-vay/phi-hang-ky-cho-vay?typeChoVay=${type}`, {}),


  listTheoChoVay: ({ chovayId, typeChoVay }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/phi-hang-ky-cho-vay-theo-cho-vay?chovayId=${chovayId}&typeChoVay=${typeChoVay}`,
      {}
    ),

    listTheoChoVay1: ( chovayId, typeChoVay ) =>
    API_AUTH.get(
      `quan-ly-cho-vay/phi-hang-ky-cho-vay-theo-cho-vay?chovayId=${chovayId}&typeChoVay=${typeChoVay}`,
      {}
    ),
};

export default PhiKhacHangKyApi;
